import { customFetch } from "@/client/custom-fetch";

import {
  IZipCode,
  TRole,
  TUserCreate,
  TUserDetails,
} from "./team-form.types";

export type TUserPermissionsResponse = {
  permissions: {
    id: string;
    code: string;
    name: string;
    description?: string;
  }[];
};

export const fetchUserPermissions = async (
  userId: string
): Promise<TUserPermissionsResponse> => {
  return customFetch<TUserPermissionsResponse>(`/users/permissions/${userId}`, {
    method: "GET",
  });
};

export const fetchZipCode = async (zipcode: string): Promise<IZipCode | null> => {
    const cleanZipcode = zipcode?.replace(/[^0-9]/g, "");
    if (cleanZipcode?.length !== 8) return null;

    try {
        const exists = await customFetch<IZipCode>(`/zipcodes/${cleanZipcode}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });
        return exists || null;
    } catch {
        return null;
    }
};

export const fetchRoles = async (): Promise<TRole[]> => {
    const roles = await customFetch<TRole[]>(`/roles`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
    });

    return roles;
};

export const createUser = async (data: TUserCreate): Promise<string> => {
    return customFetch<string>(`/users`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
}

export const updateUser = async (userId: string, data: TUserCreate): Promise<string> => {
    return customFetch<string>(`/users/${userId}`, {
        method: "PATCH",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
}

export const getUserById = async (userId: string): Promise<TUserDetails> => {
    return customFetch<TUserDetails>(`/users/${userId}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
}
